export const CASE_NUMBER = 'enrollCaseNumber';
export const APPLICATION_YEAR = 'applicationYear';
export const SEP_END_DATE = 'sepEndDate';

export const enum PlAN_TYPES {
    HEALTH = 'HEALTH',
    DENTAL = 'DENTAL',
};

export const enum GroupCSRLevels {
    CS1 = 'CS1',
    CS2 = 'CS2',
    CS3 = 'CS3',
    CS4 = 'CS4',
};

export const enum GroupTypes {
    SINGLE = 'SINGLE',
    MULTI = 'MULTI'
};

export const enum EnrolledGroupCTAButtonTypes {
    'IS_BLANK' = 'IS_BLANK',
    'IS_CHANGE_PLAN' = 'IS_CHANGE_PLAN',
    'IS_FINALIZE_ENROLLMENT' = 'IS_FINALIZE_ENROLLMENT',
    'IS_FINALIZE_PLAN' = 'IS_FINALIZE_PLAN',
    'IS_RENEW_OR_CHANGE_PLAN' = 'IS_RENEW_OR_CHANGE_PLAN',
};

export const PLAN_EXPIRATION_WARNING = 'This action is not permitted as your coverage through this plan is ending soon.';

export const ERROR_FORMING_GROUPS_PRIORITY = [
    'multiGroupFailureNotAllowed',
    'multiGroupFailureNonStandardNotAllowed', 
    'multiGroupFailureOverageMember'
];